import { ellipsis } from 'polished'

import styled from '@emotion/styled'

import { mediaQueryUp } from '~/theme/utils/grid'
import { Body2, h6 } from '~/theme/utils/typography'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`

export const TextWrapper = styled.div`
  font-size: ${({ theme }) => theme.text.fontSize.m};
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  padding: 1rem 0 1rem 1rem;
  overflow-x: hidden;
`

export const Title = styled.div`
  ${props => h6(props)};
  font-weight: ${({ theme }) => theme.text.fontWeight.medium};
  margin-bottom: 2px;
`

export const Description = styled(Body2)`
  width: 100%;
  font-weight: ${({ theme }) => theme.text.fontWeight.regular};
  color: ${({ theme }) => theme.colors.gray[700]};
  ${ellipsis()}

  ${mediaQueryUp('m')} {
    ${props => h6(props)};
  }
`

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 80px;
  height: 80px;
  border-radius: 6px;
  flex-shrink: 0;

  background-color: ${({ theme }) => theme.colors.gray[200]};
`
